<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection
            title="How many sets would you like to sponsor for a public school teen?"
          >
            <div>
              <AmountSelectorListNcsyNjSimchateinu />
              <ErrorLabel field="amount" />
            </div>
            <div class="radio__label">Please send the sets to:</div>
            <div class="radio-part">
              <input
                id="type_attending"
                name="Labelfor"
                type="radio"
                :checked="getValue('custom.sendaddress') == 'no'"
                @click="setValue('custom.sendaddress', 'no')"
              />
              <FormLabel for="type_attending"> Public school teens </FormLabel>
            </div>
            <div class="radio-part">
              <input
                name="Labelfor"
                id="speciifc__address"
                type="radio"
                :checked="getValue('custom.sendaddress') == 'yes'"
                @click="setValue('custom.sendaddress', 'yes')"
              />
              <FormLabel for="speciifc__address"> Send to a specific address </FormLabel>
            </div>
            <FormRow v-if="getValue('custom.sendaddress') == 'yes'">
              <div style="width: 100%; padding-top: 10px">
                <FormLabel class="control-label">
                  Please fill in Names and Addresses of the people you want to send sets
                  to:
                </FormLabel>
                <FormInput
                  type="textarea"
                  class="width-full"
                  field="custom.namesAddress"
                />
              </div>
            </FormRow>
          </FormSection>

          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>

            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>       
            <br />
            <InHonorOf />
          </FormSection>
          <FormSection title="Billing Address">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
            <br />
            <div class="subnote">
              If you would like to purchase your own set please click
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://esrogheadquarters.com/?ref=NCSY"
                >here</a
              >.
            </div>
          </FormSection>
          <PaymentButton showAmount btnText="Submit" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { onMounted } from "vue";
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  setup(props) {
    const { setValue, getValue, form, submit } = usePaymentForm();

    setValue("custom.sendaddress", "no");
    return {
      form,
      setValue,
      getValue,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
.form-container.ou-donation-form {
  margin: 0px;
  padding: 0px;
  box-shadow: none;
  max-width: 100%;
}
h2 {
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 0px;
  font-size: 20px;
  color: black;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.note {
  font-style: italic;
  line-height: 1.4;
  font-weight: bold;
  font-size: 14px;

  a {
    text-decoration: none;
  }
}
::v-deep .amount-row {
  min-width: 31.3333% !important;
  max-width: 31.3333% !important;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  label {
    font-weight: 500;
    background: #0c3450 !important;
    color: white !important;
    display: block !important;
  }
  input[type="radio"]:checked + label {
    background: #be9e5f !important;
  }
  .label-description {
    background: none !important;
    display: block !important;
    text-align: center !important;
    font-size: 17px;
    font-style: italic;
    padding-top: 0;
    color: white !important;
  }
  .label-amount {
    background: none !important;
    display: block !important;
    height: auto !important;
    max-width: 100%;
    min-width: 100% !important;
    border: none !important;
    font-size: 18px;
    text-align: center;
  }
  .amount_other__wrapper::before {
    background: #0c3450 !important;
    color: white !important;
    font-weight: bold;
  }
}

.subnote {
  width: 100%;
  font-size: 14px;
  color: #222;
  padding-top: 3px;
  padding-bottom: 20px;
  display: block;
  line-height: inherit;
  font-family: inherit;
  letter-spacing: normal;
  margin-bottom: 9px;
  border-bottom: 1px solid #ccc;
  a {
    color: #1aa8d3;
    text-decoration: none;
  }
}
.radio-part {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 7px;
}
.radio__label {
  margin-bottom: 10px;
  margin-top: 30px;
}
.radio-part label {
  margin: 0px;
  padding: 0px;
  line-height: normal;
}
</style>
